module.exports = [
  {
    url:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKI7qN7sUrSClCERX2hVVHbrRq4QYbKs8kWQ&usqp=CAU',
    name: 'Bag',
    deadline: '4/3/2021',
    ssn: 'EB5A7F',
    color: 'black',
    price: '$2,000',
    collection: 'fall 2021',
  },
  {
    url:
      'https://gloimg.zafcdn.com/zaful/pdm-product-pic/Clothing/2017/09/13/goods-first-img/1505265616521459710.JPG',
    name: 'Jacket',
    deadline: '4/3/2021',
    ssn: 'TT22ZV',
    color: 'red',
    price: '$6,000',
    collection: 'fall 2021',
  },
  {
    url:
      'https://en.louisvuitton.com/images/is/image/lv/1/PP_VP_L/louis-vuitton-insider-pumps-shoes--AJIE1HTC02_PM2_Front%20view.jpg',
    name: 'Shoes',
    deadline: '4/3/2021',
    ssn: 'UB5C7F',
    color: 'black',
    price: '$1,000',
    collection: 'winter 2020',
  },
  {
    url:
      'https://ae01.alicdn.com/kf/HTB1G5luXPnuK1RkSmFPq6AuzFXaA/VIKEDUO-Green-Patina-Lace-Up-Full-Brogue-Genuine-Cow-Leather-Customize-Handmade-Shoes-Wedding-Office-Motorcycle.jpg',
    name: 'Boots',
    deadline: '4/3/2021',
    ssn: 'ZZ5A7F',
    color: 'green',
    price: '$2,000',
    collection: 'fall 2021',
  },
  {
    url:
      'https://cdn11.bigcommerce.com/s-avwfcqko0c/images/stencil/1280x1280/products/490/915/5538_Tiburon_NASA_White_1_2__36571.1582931375.jpg?c=2',
    name: 'Jacket',
    deadline: '4/3/2021',
    ssn: 'EB5A7F',
    color: 'white',
    price: '$1,800',
    collection: 'fall 2021',
  },
  {
    url:
      'https://wwws.dior.com/couture/ecommerce/media/catalog/product/cache/1/zoom_image_1/3000x2000/17f82f742ffe127f42dca9de82fb58b1/r/1/1604925906_M0446CWGH_M41R_E01_ZH.jpg',
    name: 'Bag',
    deadline: '4/3/2021',
    ssn: 'BF577F',
    color: 'red',
    price: '$1,000',
    collection: 'fall 2021',
    variant: 'clutch',
  },
];
